const statusList = {
  PENDING: {
    code: 'PENDING',
    title: 'returns.verdict_processing',
    color: 'blue',
  },
  CONFIRM_RETURN: {
    code: 'CONFIRM_RETURN',
    title: 'returns.verdict_confirmed',
    color: 'green',
  },
  DENY_RETURN: {
    code: 'COURIER_REJECT',
    title: 'returns.verdict_denied',
    color: 'volcano',
  },
  IN_PROGRESS: {
    code: 'IN_PROGRESS',
    title: 'returns.verdict_in_progress',
    color: 'blue',
  },
  ARRIVE_TO_SELLER: {
    code: 'ARRIVE',
    title: 'returns.verdict_seller_processing',
    color: 'blue',
  },
  ARRIVE_CONFIRM: {
    code: 'ACCEPT',
    title: 'returns.verdict_seller_accept',
    color: 'green',
  },
  REJECT: {
    code: 'REJECT',
    title: 'returns.verdict_seller_reject',
    color: 'volcano',
  },
  TECHNICALLY_REJECT: {
    code: 'TECHNICALLY_REJECT',
    title: 'returns.verdict_tech_reject',
    color: 'volcano',
  },
  FINAL_CONFIRM: {
    code: 'CLOSE',
    title: 'returns.verdict_final_accept',
    color: 'green',
  },
  FINAL_REJECT: {
    code: 'ADMIN_REJECT',
    title: 'returns.verdict_final_reject',
    color: 'volcano',
  },
}

export default statusList
